import { AccountTreeOutlined, HealthAndSafetyOutlined, MonitorHeartOutlined, TodayOutlined } from '@mui/icons-material'
import { Avatar, Box } from '@mui/material'
import { useHistory } from 'react-router-dom'
import AutomationStatus from '../automation-status'
import KanbanCardStatus from '../kanban-card-status'
import { useStyles } from './styles'

interface KanbanCard {
  healthPlanName: string
  isHealthPlan: boolean
  date: string
  clientName: string
  familyName: 'movimentation' | 'implantation'
  isFinalized: boolean
}

const KanbanCard = ({ healthPlanName, isHealthPlan, date, clientName, familyName, isFinalized }: KanbanCard) => {
  const classes = useStyles()
  const history = useHistory()

  const automations = [
    {
      name: 'Minha base',
      status: 'finished',
    },
    {
      name: 'Regras de contrato',
      status: `${isFinalized ? 'finished' : 'pending'}`,
    },
    {
      name: 'Elegibilidade',
      status: `${isFinalized ? 'finished' : 'pending'}`,
    },
    {
      name: 'Aprovação de compras',
      status: `${isFinalized ? 'finished' : 'pending'}`,
    },
    {
      name: 'Exportação de arquivo',
      status: `${isFinalized ? 'finished' : 'pending'}`,
    },
  ]

  const handleNavigate = () => {
    history.push(
      '/contract/ae09ddd3-74a6-4620-ae61-ea93b282bbc1/43b297f7-8e4f-43da-927b-576e8149333f/b38c38af-6bcb-47f7-955a-3ae25bd66ce4'
    )
  }

  return (
    <Box
      className={classes.cardContainer}
      onClick={handleNavigate}
    >
      <Box className={classes.infoContainer}>
        <Box className={classes.clientInfoContainer}>
          <Avatar sx={{ width: 24, height: 24, fontSize: '12px' }}>{clientName.charAt(0).toUpperCase()}</Avatar>
          <span className={classes.title}>{clientName}</span>
        </Box>
        <KanbanCardStatus status={familyName} />
      </Box>

      <Box className={classes.healthPlanContainer}>
        {isHealthPlan ? (
          <MonitorHeartOutlined
            sx={{
              color: '#8C8C93 !important',
              width: '16px',
            }}
          />
        ) : (
          <HealthAndSafetyOutlined
            sx={{
              color: '#8C8C93 !important',
              width: '16px',
            }}
          />
        )}

        <span className={classes.title}>{healthPlanName}</span>
      </Box>

      <Box className={classes.automationsContainer}>
        <Box className={classes.automationTitleContainer}>
          <AccountTreeOutlined
            sx={{
              color: '#8C8C93 !important',
              width: '16px',
            }}
          />
          <span className={classes.title}>Automações</span>
        </Box>
        {automations.map((automation, index) => (
          <Box
            className={classes.projectAutomationsContainer}
            key={index}
          >
            <span className={classes.automationName}>{automation.name}</span>
            <AutomationStatus status={automation.status as 'finished' | 'pending'} />
          </Box>
        ))}
      </Box>

      <Box className={classes.dateContainer}>
        <TodayOutlined
          sx={{
            color: '#8C8C93 !important',
            width: '16px',
          }}
        />
        <span className={classes.automationName}>{date}</span>
      </Box>
    </Box>
  )
}

export default KanbanCard
